import { secretStorage } from "config"
import { cloneDeep, isEmpty } from "lodash"
import { useDispatch, useSelector } from "react-redux"
import { actions } from "store"

const updatePulldownStorage = (key, values) => {
    const user = secretStorage.getItem("user")
    const { user_data } = user || {}

    let nUser_data = cloneDeep(user_data?.[0])
    // let nUser_data = cloneDeep(user_data[0].user_data)
    nUser_data[key] = values
    let nUser = { ...user, user_data: nUser_data }
    secretStorage.setItem("user", nUser)
}

const useHandleGroup = () => {
    const dispatch = useDispatch()
    const { roleIndex } = useSelector(state => state.user)

    return (filters) => {
        const user = secretStorage.getItem("user")
        const { user_data } = user || {}
        const { affiliations, grades, classes, affiliation_groups } = user_data?.[roleIndex]?.user_data || {}

        if (filters?.group?.id)
            if (!isEmpty(affiliations) && !isEmpty(filters)) {
                const nAffiliations = affiliations.filter(
                    affiliation =>
                        affiliation.group === filters?.group?.id)


                dispatch(actions.setAffiliations(nAffiliations))
            }
    }
}

const useHandleAffiliation = () => {
    const dispatch = useDispatch()
    const { roleIndex } = useSelector(state => state.user)

    return (filters) => {
        const user = secretStorage.getItem("user")
        const { user_data } = user || {}
        const { affiliations, learning_groups } = user_data?.[roleIndex]?.user_data || {}

        // if (filters?.school?.id)
        if (!isEmpty(affiliations) && !isEmpty(filters)) {
            const nLearningGroups = learning_groups.filter(
                lGroup => lGroup.affiliation === filters?.affiliation?.id
            )

            console.log("nLearningGroups", nLearningGroups)
            dispatch(actions.setLearningGroups(nLearningGroups))
        }
    }
}

const useHandleGrade = () => {
    const dispatch = useDispatch()
    const { roleIndex } = useSelector(state => state.user)

    return (filters) => {
        const user = secretStorage.getItem("user")
        const { user_data } = user || {}
        const { affiliations, grades, classes, affiliation_groups } = user_data?.[roleIndex]?.user_data || {}

        if (!isEmpty(grades) && !isEmpty(filters)) {
            const nClassess = classes.filter(
                schoolClass =>
                    schoolClass.grade === filters?.grade?.id
                    &&
                    (
                        schoolClass.affiliation === filters?.affiliation?.id ||
                        schoolClass.affiliation === filters?.school?.id
                    )
            )

            console.log("nClassess", nClassess, filters?.grade?.id, filters?.affiliation?.id)
            dispatch(actions.setSchoolClasses(nClassess))
        }
    }
}

const useCleanSchoolClassess = () => {
    const dispatch = useDispatch()

    return () => dispatch(actions.setSchoolClasses(null))
}

const useCleanLearningGroups = () => {
    const dispatch = useDispatch()

    return () => dispatch(actions.setLearningGroups(null))
}

const useDefaultValue = () => {
    const dispatch = useDispatch()
    const { roleIndex } = useSelector(state => state.user)

    return (nUser) => {
        const currentUser = nUser || secretStorage.getItem("user")
        const { user_data } = currentUser || {}
        const { affiliations, grades, classes, affiliation_groups } = user_data?.[roleIndex]?.user_data || {}

        let header = {}
        if (affiliation_groups?.length === 1) {
            header.group = affiliation_groups[0]
        }
        if (affiliations?.length === 1) {
            header.affiliation = affiliations[0]
        }
        if (grades?.length === 1) {
            header.grade = grades[0]
        }
        if (classes?.length === 1) {
            header.school_class = classes[0]
        }

        if (!isEmpty(header))
            dispatch(actions.setHeaderFilters(header))
    }

}

export default { useCleanLearningGroups, useCleanSchoolClassess, updatePulldownStorage, useDefaultValue, useHandleAffiliation, useHandleGrade, useHandleGroup }
